<section class="title-bar content-padding first-item ">
  <div class="wrapper nowrap">
    <!-- <h2 class="title-heading">Prodotti</h2> -->
    <div class="item nowrap">
      <span class="btn-container top-button-container">
        <input type="file" name="file" class="custom-file-input" id="importcsv" required (change)="handleImport($event)" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" hidden>
        
          <button routerLink="/prodotti/nuovo" class="btn btn-white vertical align-items-center"  *ngIf="selected === 'active'">
            Aggiungi<i class="ml-10 fas fa-plus"></i>
          </button>

          <button class="btn btn-white vertical align-items-center" (click)="export()">
            Esporta<i class="ml-10 fas fa-file-excel"></i>
          </button>

          <button class="btn btn-white vertical align-items-center" (click)="import()" *ngIf="(groups.includes('admin') || groups.includes('operation'))">
            Importare<i class="ml-10 fas fa-file-excel"></i>
          </button>

          <button class="btn btn-white vertical align-items-center" (click)="show('table')">
            Tabella<i class="ml-10 fas fa-bars"></i>
          </button>

          <button class="btn btn-white vertical align-items-center" (click)="show('grid')">
            Griglia<i class="ml-10 fas fa-th"></i>
          </button>

          <button class="btn full-width-btn vertical align-items-center" (click)="downloadCsvFormat()">
            Scarica il formato CSV
          </button>

          <button 
            class="btn full-width-btn vertical align-items-center" 
            [disabled]="!selectedProducts.length" 
            (click)="hanldeMultipleDelete()"
            *ngIf="selected === 'active'"
            >
            Eliminazione multipla<i class="ml-10 far fa-trash-alt"></i>
          </button>

          <select 
            class="btn-white full-width-btn vertical align-items-center" 
            [disabled]="!selectedProducts.length" 
            (change)="handleMultipleStatusChange($event.target.value)"
            *ngIf="selected === 'active'"
            >
            <option value="" selected disabled>Seleziona Stato</option>
            <option *ngFor="let status of productStatus" [value]="status.value">
              {{status.ln.it}}
            </option>
          </select>

      </span>
    </div>
  </div>
</section>

<section class="main-content wrapper content-padding scroll-delivery">
  <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)" *ngIf="searchPartner.length == 0">
  </app-pagination>
  <ng-template [ngIf]="showElem == 'table'">
    <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
      <form class="table-row-container row first-row filter" [formGroup]="_productFilterForm" (ngSubmit)="filter()" *ngIf="_productFilterForm">
        <div class="item data-col-5">
          <h4 class="title">
            <i class="sort-icon fas"></i></h4>
          <span class="data"></span>
        </div>
        <div class="item data-col-10">
          <h4 class="title" (click)="navigateOrder('Product.id')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.id')"></i>
            ID</h4>
          <span class="data">
            <input type="text" formControlName="Product.id" style="width: 130px;">
          </span>
        </div>
        <div class="item data-col-10">
          <h4 class="title">
            FOTO
          </h4>
          <span class="data"></span>
        </div>
        <div class="item data-col-25">
          <h4 class="title" (click)="navigateOrder('Product.name')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.name')"></i>
            NOME
          </h4>
          <span class="data">
            <input type="text" formControlName="Product.name" style="width: 130px;">
          </span>
        </div>

        <!-- <div class="item data-col-25" *ngIf="(groups.includes('admin') || groups.includes('operation'))"> -->
        <div class="item data-col-25">
          <h4 class="title" (click)="navigateOrder('ProductVariants.variantSku')">
            <i class="sort-icon fas" [ngClass]="orderIcon('ProductVariants.variantSku')"></i>
            VARIANTE SKU
          </h4>
          <span class="data">
            <input type="text" formControlName="ProductVariants.variantSku" style="width: 90px;">
          </span>
        </div>

        <div class="item data-col-15">
          <h4 class="title" (click)="navigateOrder('ProductCategory.categoryName')">
            <i class="sort-icon fas" [ngClass]="orderIcon('ProductCategory.categoryName')"></i>
            PRODOTTO CATEGORIA
          </h4>
          <span class="data">
            <input type="text" formControlName="ProductCategory.categoryName">
          </span>
        </div>

        <div class="item data-col-10">
          <h4 class="title" (click)="navigateOrder('Product.price')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.price')"></i>
            PREZZO
          </h4>
          <span class="data">
            <select formControlName="Product.price.operator" style="width: 40px;">
              <option value="equal">=</option>
              <option value="lessThan"><</option>
              <option value="moreThan">></option>
            </select>
            <input type="number" formControlName="Product.price" style="width: 100px;">
          </span>
        </div>

        <div class="item data-col-10" *ngIf="(groups.includes('admin') || groups.includes('operation'))">
          <h4 class="title" (click)="navigateOrder('Product.shopifyPrice')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.shopifyPrice')"></i>
            PREZZO PUBBLICO
          </h4>
          <span class="data">
            <select formControlName="Product.shopifyPrice.operator" style="width: 40px;">
              <option value="equal">=</option>
              <option value="lessThan"><</option>
              <option value="moreThan">></option>
            </select>
            <input type="number" formControlName="Product.shopifyPrice" style="width: 100px;">
          </span>
        </div>

        <div class="item data-col-10">
          <h4 class="title" (click)="navigateOrder('Product.productAvailability')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.productAvailability')"></i>
            STOCK
          </h4>
          <span class="data">
            <select formControlName="Product.productAvailability.operator" style="width: 40px;">
              <option value="equal">=</option>
              <option value="lessThan"><</option>
              <option value="moreThan">></option>
            </select>
            <input type="text" formControlName="Product.productAvailability" style="width: 100px;">
          </span>
        </div>

        <div class="item data-col-25" *ngIf="(groups.includes('admin') || groups.includes('operation'))">
          <h4 class="title" (click)="navigateOrder('Partner1.businessName')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Partner1.businessName')"></i>
            PARTNER
          </h4>
          <span class="data">
            <input type="text" formControlName="Partner1.businessName">
          </span>
        </div>

        <!-- <div class="item data-col-25" *ngIf="(groups.includes('admin') || groups.includes('operation'))"> -->
        <div class="item data-col-25">
          <h4 class="title" (click)="navigateOrder('Product.sku')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.sku')"></i>
            SKU
          </h4>
          <span class="data">
            <input type="text" formControlName="Product.sku" style="width: 90px;">
          </span>
        </div>

        <div class="item data-col-25" *ngIf="(groups.includes('admin') || groups.includes('operation'))">
          <h4 class="title" (click)="navigateOrder('Product.isSuperProduct')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.isSuperProduct')"></i>
            SUPER PRODOTTO
          </h4>
          <span class="data">
            <select formControlName="Product.isSuperProduct" style="width: 130px;">
              <option value="">Tutti</option>
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </span>
        </div>

        <div class="item data-col-25" *ngIf="(groups.includes('admin') || groups.includes('operation'))">
          <h4 class="title" (click)="navigateOrder('Product.isSuperProvinceProduct')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.isSuperProvinceProduct')"></i>
            SUPER PROVINCIA
          </h4>
          <span class="data">
            <select formControlName="Product.isSuperProvinceProduct" style="width: 130px;">
              <option value="">Tutti</option>
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </span>
        </div>

        <div class="item data-col-25" *ngIf="(groups.includes('admin') || groups.includes('operation'))">
          <h4 class="title" (click)="navigateOrder('Product.uniqueProduct')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.uniqueProduct')"></i>
            PRODOTTO UNICO
          </h4>
          <span class="data">
            <select formControlName="Product.uniqueProduct" style="width: 130px;">
              <option value="">Tutti</option>
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </span>
        </div>

        <div class="item data-col-25" *ngIf="groups.includes('admin') || groups.includes('operation') || groups.includes('partner')">
          <h4 class="title" (click)="navigateOrder('Product.adminApproval')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.adminApproval')"></i>
            APPROVATO
          </h4>
          <span class="data">
            <select formControlName="Product.adminApproval" style="width: 130px;">
              <option value="">Tutti</option>
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </span>
        </div>

        <div class="item data-col-25">
          <h4 class="title" (click)="navigateOrder('Product.inStock')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.inStock')"></i>
            IN MAGAZZINO
          </h4>
          <span class="data">
            <select formControlName="Product.inStock" style="width: 130px;">
              <option value="">Tutti</option>
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </span>
        </div>

        <div class="item data-col-10 center" *ngIf="(groups.includes('admin') || groups.includes('operation') || groups.includes('partner'))">
          <h4 class="title" (click)="navigateOrder('Product.productStatus')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.productStatus')"></i>
            ATTIVO
          </h4>
          <span class="data">
            <select formControlName="Product.productStatus">
              <option value="">Tutti</option>
              <option *ngFor="let status of productStatus" [value]="status.value">
                {{status.ln.it}}
              </option>
            </select>
          </span>
        </div>

        <div class="item data-col-5 hideOnPhoneView">
          <h4 class="title">AZIONI</h4>
          <span class="data saifu">
            <button class="btn hvr-grow" (click)="$event.preventDefault(); filter()">
              <i class="fas fa-search"></i>
            </button>
            <button class="btn hvr-grow" (click)="$event.preventDefault(); resetFilter()">
              <i class="fas fa-undo"></i>
            </button>
          </span>
        </div>

      </form>

      <div class="table-row-container row" *ngIf="products?.length">
        <div class="select-all">
          <input 
            type="checkbox" 
            id="checkAll" 
            style="cursor: pointer;" 
            [checked]="areAllSelectableProductsSelected()" 
            (change)="selectAllProducts($event)" 
          />
          <label for="checkAll" style="cursor: pointer;">Seleziona Tutti</label>
        </div>
      </div>

      <div class="table-row-container row" [ngClass]="checkParentProduct(product) ? 'parent-product' : 'no-parent-product'" *ngFor="let product of products | filter:searchPartner; index as i">

        <div class="item data-col-5">
          <span class="data-row-left">
            <input 
              type="checkbox" 
              style="cursor: pointer;" 
              [disabled]="isProductDisabled(product)" 
              [id]="'checkbox_' + product.id" 
              [checked]="isSelected(product)" 
              (change)="toggleSelection(product)" 
            />
          </span>
        </div>

        <div class="item data-col-10">
          <h4 class="title">Id</h4>
          <span class="data data-id id-num">{{product.id}}</span>
        </div>
        <div class="item data-col-10">
          <h4 class="title">Foto</h4>
          <span class="data imgs-col" style="cursor: pointer">
            <img 
              [src]="product?.image || 'assets/img/no-image.jpg'"
              [alt]="product?.name || 'Prodotto'"
              class="product-image" 
              (click)="openImage(product?.image? product?.image : 'assets/img/no-image.jpg')"
            >
          </span>
        </div>
        <div class="item data-col-25">
          <h4 class="title" (click)="navigateOrder('Product.name')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.name')"></i>
            Nome prodotto
          </h4>
          <span class="data" (click)="showVariant(product.id)">{{product.name}}</span>
          <div class="overlay" [ngClass]="{'show': isProductOpen(product.id)}" (click)="closeOverlay(product.id)"></div>
          <div class="card-container" [ngClass]="{'visible': isProductOpen(product.id)}">
            <div class="acc-header">
              <div class="flex-box">
                <div class="flex-col">
                  <div class="event-name">
                    <span class="text">PRODOTTO & VARIANTI</span>
                    <b class="text">{{product.name}}</b>
                  </div>
                </div>
              </div>
              <span class="close-icon" (click)="closeOverlay(product.id)">&#x2715;</span>
            </div>
            <div class="accordion-body" *ngIf="isProductOpen(product.id)">

              <ng-container *ngIf="product?.productVariants.length > 0; else noVariants">
                <div class="additional-info" [ngClass]="{'border-in-stock': variant.variantInStock, 'border-out-stock': !variant.variantInStock}" *ngFor="let variant of product?.productVariants">
                  <div>
                    <p class="para">
                      <strong>{{ variant.variantName || "N/A" }}</strong>- {{ variant.variantSku || "N/A" }}
                    </p>
                    <p class="para">
                      <strong>Prezzo</strong>- € {{ variant.variantPrice || "0" }}
                    </p>
                    <p class="para" *ngIf="groups.includes('admin') || groups.includes('operation')">
                      <strong>Prezzo Pubblico</strong>- € {{ variant.variantShopifyPrice || "0" }}
                    </p>
                    <p class="para">
                      <strong>Stock</strong>- {{ variant.variantAvailability || "0" }}
                    </p>
                  </div>

                  <div>
                    <input 
                      type="checkbox" 
                      id="toggle-product-{{variant.id}}" 
                      class="toggle-switch" 
                      [(ngModel)]="variant.variantInStock"
                      (change)="onToggleChange(variant.id)"
                    />
                    <label for="toggle-product-{{variant.id}}" class="switch-label"></label>
                  </div>

                  <div 
                    *ngIf="!variant.variantInStock" 
                    class="badge sold-out-badge" 
                    [ngClass]="{'badge-left': !variant.variantInStock, 'badge-right': variant.variantInStock}">
                    Sold Out
                  </div>
                  <div 
                    *ngIf="variant.variantInStock" 
                    class="badge in-stock-badge"
                    [ngClass]="{'badge-left': variant.variantInStock, 'badge-right': !variant.variantInStock}">
                    In Stock
                  </div>

                </div>
              </ng-container>
              <ng-template #noVariants>
                <span class="text">NO VARIANTI</span>
              </ng-template>
            </div>
          </div>
        </div>

        <!-- <div class="item center data-col-25" *ngIf="(groups.includes('admin') || groups.includes('operation'))"> -->
        <div class="item center data-col-25">
          <h4 class="title" (click)="navigateOrder('ProductVariants.variantSku')">
            <i class="sort-icon fas" [ngClass]="orderIcon('ProductVariants.variantSku')"></i>
            VARIANT SKU
          </h4>
          <span class="data" (click)="showVariant(product.id)">{{ getVariantSkus(product) }}</span>
        </div>

        <div class="item data-col-15">
          <h4 class="title" (click)="navigateOrder('ProductCategory.categoryName')">
            <i class="sort-icon fas" [ngClass]="orderIcon('ProductCategory.categoryName')"></i>
            Prodotto Categoria
          </h4>
          <span class="data" (click)="showVariant(product.id)">{{product.productCategory ? product.productCategory?.categoryName?.toUpperCase() : "N/A" }}</span>
        </div>
        <div class="item data-col-10">
          <h4 class="title" (click)="navigateOrder('Product.price')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.price')"></i>
            Prezzo
          </h4>
          <span class="data" (click)="showVariant(product.id)">€ {{product.price || 0 | number:'1.2-2'}}</span>
        </div>
        <div class="item data-col-10" *ngIf="(groups.includes('admin') || groups.includes('operation'))" >
          <h4 class="title" (click)="navigateOrder('Product.shopifyPrice')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.shopifyPrice')"></i>
            Prezzo Pubblico
          </h4>
          <span class="data" (click)="showVariant(product.id)">€ {{product.shopifyPrice || 0 | number:'1.2-2'}}</span>
        </div>
        <div class="item center data-col-10">
          <h4 class="title" (click)="navigateOrder('Product.productAvailability')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.productAvailability')"></i>
            Stock
          </h4>
          <span class="data" (click)="showVariant(product.id)">{{product.productAvailability || "0" }}</span>
        </div>
        <div class="item center data-col-10" *ngIf="(groups.includes('admin') || groups.includes('operation'))">
          <h4 class="title" (click)="navigateOrder('Partner.businessName')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
            Partner
          </h4>
          <span class="data" (click)="showVariant(product.id)">{{ (product.partner?.businessName) ? product.partner?.businessName : ''}}</span>
        </div>

        <!-- <div class="item center data-col-10" *ngIf="(groups.includes('admin') || groups.includes('operation'))"> -->
        <div class="item center data-col-10">
          <h4 class="title" (click)="navigateOrder('Product.sku')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.sku')"></i>
            SKU
          </h4>
          <span class="data" (click)="showVariant(product.id)">{{ product.sku || "N/A" }}</span>
        </div>
        <div class="item data-col-10" *ngIf="(groups.includes('admin') || groups.includes('operation'))">
          <h4 class="title" (click)="navigateOrder('Product.isSuperProduct')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.isSuperProduct')"></i>
            SUPER PRODUCT
          </h4>
          <span class="data" (click)="showVariant(product.id)">{{ product.isSuperProduct ? "Yes" : "No" }}</span>
        </div>
        <div class="item data-col-10" *ngIf="(groups.includes('admin') || groups.includes('operation'))">
          <h4 class="title" (click)="navigateOrder('Product.isSuperProvinceProduct')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.isSuperProvinceProduct')"></i>
            SUPER PROVINCE
          </h4>
          <span class="data" (click)="showVariant(product.id)">{{ product.isSuperProvinceProduct ? "Yes" : "No" }}</span>
        </div>
        <div class="item data-col-25" *ngIf="(groups.includes('admin') || groups.includes('operation'))">
          <h4 class="title" (click)="navigateOrder('Product.uniqueProduct')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.uniqueProduct')"></i>
            Unique Product
          </h4>
          <div class="data">
            <select (change)="changeUniqueProduct(product.id, $event.target.value)" [disabled]="disable">
              <option *ngFor="let dt of yesNoStatus" [value]="dt.value" [selected]="dt.value == product.uniqueProduct">
                {{ dt.ln.it }}
              </option>
            </select>
          </div>
        </div>
        <div class="item data-col-10" *ngIf="groups.includes('admin') || groups.includes('operation')">
          <h4 class="title" (click)="navigateOrder('Product.adminApproval')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.adminApproval')"></i>
            APPROVATO
          </h4>
          <div class="data">
            <select (change)="changeAdminApproval(product.id, $event.target.value)" [disabled]="disable">
              <option *ngFor="let dt of yesNoStatus" [value]="dt.value" [selected]="dt.value == product.adminApproval">
                {{ dt.ln.it }}
              </option>
            </select>
          </div>
        </div>
        <div class="item data-col-10" *ngIf="groups.includes('partner')">
          <h4 class="title" (click)="navigateOrder('Product.adminApproval')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.adminApproval')"></i>
            APPROVATO
          </h4>
          <span class="data">
            {{ product.adminApproval ? "Yes" : "No" }}
          </span>
        </div>
        <div class="item data-col-10">
          <h4 class="title" (click)="navigateOrder('Product.inStock')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.inStock')"></i>
            IN STOCK
          </h4>
          <div class="data">
            <select (change)="changeInStockStatus(product.id, $event.target.value)" [disabled]="disable">
              <option *ngFor="let dt of yesNoStatus" [value]="dt.value" [selected]="dt.value == product.inStock">
                {{ dt.ln.it }}
              </option>
            </select>
          </div>
        </div>
        <div class="item data-col-10 center" *ngIf="(groups.includes('admin') || groups.includes('operation') || groups.includes('partner'))">
          <h4 class="title" (click)="navigateOrder('Product.productStatus')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.productStatus')"></i>
            Attivo
          </h4>
          <div class="data">
            <select 
              (change)="changeProductStatus(product.id, $event.target.value)" 
              [disabled]="(groups.includes('partner') && product?.partner && (product.partner.id != loggedInPartner?.id) || disable)" >
              <option *ngFor="let status of productStatus" [value]="status.value" [selected]="status.value == product.productStatus">
                {{status.ln.it}}
              </option>
            </select>
          </div>
        </div>

        <div class="item nowrap">
          <span class="data-row-left btn-container">
            <button
              class="btn hvr-grow has-margin-right"
              *ngIf="(groups.includes('admin') || groups.includes('operation') || groups.includes('partner')) && (selected === 'active')"
              (click)="redirectUser(product.id, 'delivery')"
            >
              NUOVA CONSEGNA
              <i class="fas fa-external-link-alt"></i>
            </button>

            <button
              class="btn hvr-grow has-margin-right"
              *ngIf="(groups.includes('admin') || groups.includes('operation') || groups.includes('partner')) && (selected === 'active')"
              (click)="redirectUser(product.id, 'customsale')"
            >
              NUOVA VENDITA
              <i class="fas fa-external-link-alt"></i>
            </button>

            <button 
              class="btn hvr-grow has-margin-right" 
              *ngIf="(groups.includes('admin') || groups.includes('operation'))"
              (click)="redirectUser(product.id, 'edit')"
              >
              MODIFICA
            </button>

            <button 
              class="btn hvr-grow has-margin-right" 
              *ngIf="product.unEditable === false && groups.includes('partner') && (product?.partner?.id === loggedInPartner?.id)" 
              (click)="redirectUser(product.id, 'edit')"
            >
              MODIFICA
            </button>

            <button 
              style="width: 100%;"
              class="btn hvr-grow has-margin-right align-items-center" 
              *ngIf="product.controlStock && !product.productHasVariants"
              (click)="openAddStock(product)"
            >
              AGGIUNGI STOCK
            </button>

            <button
              type="button"
              class="btn hvr-grow has-margin-right align-items-center" 
              *ngIf="product.controlStock && !product.productHasVariants"
              (click)="openStockDetails(product)"
            >
              Visualizza stock
            </button>

            <div *ngIf="product.controlStock && product.productHasVariants">
              <div
                class="variant-stock-row"
                *ngFor="let variant of product.productVariants"
              >
                <div>
                  <strong>{{ variant.variantName || 'Variante #' + variant.id }}</strong>
                  <small>Disponibile: {{ variant.variantAvailability || 0 }}</small>
                </div>

                <div class="variant-actions">
                  <button
                    type="button"
                    class="stock-btn stock-btn-primary btn hvr-grow has-margin-right align-items-center"
                    (click)="openAddVariantStock(product, variant)"
                  >
                    Aggiungi stock
                  </button>

                  <button
                    type="button"
                    class="stock-btn stock-btn-light btn hvr-grow has-margin-right align-items-center"
                    (click)="openVariantStockDetails(product, variant)"
                  >
                    Visualizza stock
                  </button>
                </div>
              </div>
            </div>

            <button 
              class="btn btn-red vertical align-items-center" 
              *ngIf="(groups.includes('admin'))" 
              (click)="delete(product.id)"
              >
              Elimina
              <i class="ml-10 far fa-trash-alt"></i>
            </button>
          </span>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template [ngIf]="showElem == 'grid'">

    <div class="custom-data-output has-margin-top scroll-delivery" role="table" id="elencoConsegnePartner">
      <form class="table-row-container row first-row filter" [formGroup]="_productFilterForm" (ngSubmit)="filter()" *ngIf="_productFilterForm">

        <div class="item data-col-5">
          <h4 class="title">
            <i class="sort-icon fas"></i>
          </h4>
          <span class="data"></span>
        </div>

        <div class="item data-col-10">
          <h4 class="title" (click)="navigateOrder('Product.id')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.id')"></i>
            ID
          </h4>
          <span class="data">
            <input type="text" formControlName="Product.id" style="width: 130px;">
          </span>
        </div>

        <div class="item data-col-10">
          <h4 class="title">
            FOTO
          </h4>
          <span class="data"></span>
        </div>

        <div class="item data-col-25">
          <h4 class="title" (click)="navigateOrder('Product.name')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.name')"></i>
            NOME
          </h4>
          <span class="data">
            <input type="text" formControlName="Product.name" style="width: 130px;">
          </span>
        </div>

        <div class="item data-col-25" *ngIf="(groups.includes('admin') || groups.includes('operation'))">
          <h4 class="title" (click)="navigateOrder('ProductVariants.variantSku')">
            <i class="sort-icon fas" [ngClass]="orderIcon('ProductVariants.variantSku')"></i>
            VARIANTE SKU
          </h4>
          <span class="data">
            <input type="text" formControlName="ProductVariants.variantSku" style="width: 90px;">
          </span>
        </div>

        <div class="item data-col-15">
          <h4 class="title" (click)="navigateOrder('ProductCategory.categoryName')">
            <i class="sort-icon fas" [ngClass]="orderIcon('ProductCategory.categoryName')"></i>
            PRODOTTO CATEGORIA
          </h4>
          <span class="data">
            <input type="text" formControlName="ProductCategory.categoryName">
          </span>
        </div>

        <div class="item data-col-10">
          <h4 class="title" (click)="navigateOrder('Product.price')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.price')"></i>
            PREZZO
          </h4>
          <span class="data">
            <select formControlName="Product.price.operator" style="width: 40px;">
              <option value="equal">=</option>
              <option value="lessThan"><</option>
              <option value="moreThan">></option>
            </select>
            <input type="number" formControlName="Product.price" style="width: 100px;">
          </span>
        </div>

        <div class="item data-col-10" *ngIf="(groups.includes('admin') || groups.includes('operation'))">
          <h4 class="title" (click)="navigateOrder('Product.shopifyPrice')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.shopifyPrice')"></i>
            PREZZO PUBBLICO
          </h4>
          <span class="data">
            <select formControlName="Product.shopifyPrice.operator" style="width: 40px;">
              <option value="equal">=</option>
              <option value="lessThan"><</option>
              <option value="moreThan">></option>
            </select>
            <input type="number" formControlName="Product.shopifyPrice" style="width: 100px;">
          </span>
        </div>

        <div class="item data-col-10">
          <h4 class="title" (click)="navigateOrder('Product.productAvailability')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.productAvailability')"></i>
            STOCK
          </h4>
          <span class="data">
            <select formControlName="Product.productAvailability.operator" style="width: 40px;">
              <option value="equal">=</option>
              <option value="lessThan"><</option>
              <option value="moreThan">></option>
            </select>
            <input type="text" formControlName="Product.productAvailability" style="width: 100px;">
          </span>
        </div>

        <div class="item data-col-25" *ngIf="(groups.includes('admin') || groups.includes('operation'))">
          <h4 class="title" (click)="navigateOrder('Partner1.businessName')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Partner1.businessName')"></i>
            PARTNER
          </h4>
          <span class="data">
            <input type="text" formControlName="Partner1.businessName">
          </span>
        </div>

        <div class="item data-col-25" *ngIf="(groups.includes('admin') || groups.includes('operation'))">
          <h4 class="title" (click)="navigateOrder('Product.sku')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.sku')"></i>
            SKU</h4>
          <span class="data">
            <input type="text" formControlName="Product.sku" style="width: 90px;">
          </span>
        </div>

        <div class="item data-col-25" *ngIf="(groups.includes('admin') || groups.includes('operation'))">
          <h4 class="title" (click)="navigateOrder('Product.isSuperProduct')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.isSuperProduct')"></i>
            SUPER PRODOTTO</h4>
          <span class="data">
            <select formControlName="Product.isSuperProduct" style="width: 130px;">
              <option value="">Tutti</option>
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </span>
        </div>

        <div class="item data-col-25" *ngIf="(groups.includes('admin') || groups.includes('operation'))">
          <h4 class="title" (click)="navigateOrder('Product.isSuperProvinceProduct')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.isSuperProvinceProduct')"></i>
            SUPER PROVINCIA</h4>
          <span class="data">
            <select formControlName="Product.isSuperProvinceProduct" style="width: 130px;">
              <option value="">Tutti</option>
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </span>
        </div>

        <div class="item data-col-25" *ngIf="(groups.includes('admin') || groups.includes('operation'))">
          <h4 class="title" (click)="navigateOrder('Product.uniqueProduct')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.uniqueProduct')"></i>
            PRODOTTO UNICO
          </h4>
          <span class="data">
            <select formControlName="Product.uniqueProduct" style="width: 130px;">
              <option value="">Tutti</option>
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </span>
        </div>

        <div class="item data-col-25" *ngIf="groups.includes('admin') || groups.includes('operation') || groups.includes('partner')">
          <h4 class="title" (click)="navigateOrder('Product.adminApproval')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.adminApproval')"></i>
            APPROVATO
          </h4>
          <span class="data">
            <select formControlName="Product.adminApproval" style="width: 130px;">
              <option value="">Tutti</option>
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </span>
        </div>

        <div class="item data-col-25">
          <h4 class="title" (click)="navigateOrder('Product.inStock')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.inStock')"></i>
            IN MAGAZZINO
          </h4>
          <span class="data">
            <select formControlName="Product.inStock" style="width: 130px;">
              <option value="">Tutti</option>
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </span>
        </div>

        <div class="item data-col-10 center" *ngIf="(groups.includes('admin') || groups.includes('operation') || groups.includes('partner'))">
          <h4 class="title" (click)="navigateOrder('Product.productStatus')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Product.productStatus')"></i>
            ATTIVO
          </h4>
          <span class="data">
            <select formControlName="Product.productStatus">
              <option value="">Tutti</option>
              <option *ngFor="let status of productStatus" [value]="status.value">
                {{status.ln.it}}
              </option>
            </select>
          </span>
        </div>

        <div class="item data-col-5 hideOnPhoneView">
          <h4 class="title">AZIONI</h4>
          <span class="data saifu">
            <button class="btn hvr-grow" (click)="$event.preventDefault(); filter()">
              <i class="fas fa-search"></i>
            </button>
            <button class="btn hvr-grow" (click)="$event.preventDefault(); resetFilter()">
              <i class="fas fa-undo"></i>
            </button>
          </span>
        </div>

      </form>
    </div>

    <div class="products-grid">
      <div class="product-card item product" *ngFor="let product of products">
        <div class="image" style="cursor: pointer;">
          <img 
            [src]="product.image || 'assets/img/no-image.jpg'"
            [alt]="product?.name || 'Prodotto'"
            (click)="openImage(product?.image? product?.image : 'assets/img/no-image.jpg')" 
          >
        </div>
        <h3>NOME: {{ product.name }}</h3>
        <p class="product-element">CATEGORIA: {{ product.productCategory ? product.productCategory?.categoryName?.toUpperCase() : "N/A" }}</p>
        <p class="product-element">PARTNER: {{ (product.partner?.businessName) ? product.partner?.businessName : 'N/A'}}</p>
        <p class="product-element">PREZZO: {{ product.price || 0 | currency:'EUR':'symbol':'1.2-2' }}</p>
        <div class="bottom-card">

          <!--
          <div class="grid-actions">
            <button class="btn-invisible" *ngIf="groups.includes('admin')" (click)="delete(product.id)">
              <i class="far fa-trash-alt hvr-grow red-text"></i>
            </button>
            <a routerLink="/prodotti/{{product.id}}" *ngIf="groups.includes('admin') || groups.includes('operation')">
              <button class="btn-invisible">
                <i class="far fa-edit hvr-grow"></i>
              </button>
            </a>
          </div>
          -->

          <div class="new-grid-actions">

            <button
              style="width: 100%;"
              class="btn hvr-grow has-margin-right"
              *ngIf="(groups.includes('admin') || groups.includes('operation') || groups.includes('partner')) && (selected === 'active')"
              (click)="redirectUser(product.id, 'delivery')"
            >
              NUOVA CONSEGNA
              <i class="fas ml-10 fa-external-link-alt"></i>
            </button>

            <button
              style="width: 100%;"
              class="btn hvr-grow has-margin-right"
              *ngIf="(groups.includes('admin') || groups.includes('operation') || groups.includes('partner')) && (selected === 'active')"
              (click)="redirectUser(product.id, 'customsale')"
            >
              NUOVA VENDITA
              <i class="fas ml-10 fa-external-link-alt"></i>
            </button>

            <button 
              style="width: 100%;"
              class="btn hvr-grow has-margin-right align-items-center" 
              *ngIf="(groups.includes('admin') || groups.includes('operation'))"
              (click)="redirectUser(product.id, 'edit')"
              >
              MODIFICA
            </button>

            <button 
              style="width: 100%;"
              class="btn hvr-grow has-margin-right align-items-center" 
              *ngIf="product.unEditable === false && groups.includes('partner') && (product?.partner?.id === loggedInPartner?.id)" 
              (click)="redirectUser(product.id, 'edit')"
            >
              MODIFICA
            </button>

            <button 
              style="width: 100%;"
              class="btn btn-red vertical align-items-center" 
              *ngIf="(groups.includes('admin'))" 
              (click)="delete(product.id)"
              >
              Elimina
              <i class="ml-10 far fa-trash-alt"></i>
            </button>
            
          </div>

        </div>
      </div>
    </div>
  </ng-template>
</section>

<div class="modal-backdrop" *ngIf="showAddStockModal">
  <div class="modal-content">
    <app-add-stock
      [productId]="selectedStockProduct?.id"
      [partnerId]="selectedStockProduct?.partner?.id"
      [productVariantId]="selectedStockVariant?.id"
      [productName]="selectedStockProduct?.name"
      [variantName]="selectedStockVariant?.variantName"
      (stockAdded)="onStockAdded($event)"
      (cancelled)="closeAddStock()"
    ></app-add-stock>
  </div>
</div>


<div class="modal-backdrop" *ngIf="showStockDetailsModal">
  <div class="modal-content modal-content-lg">
    <app-product-stock-details
      [productId]="selectedStockProduct?.id"
      [partnerId]="selectedStockProduct?.partner?.id"
      [productVariantId]="selectedStockVariant?.id"
      [productName]="selectedStockProduct?.name"
      [variantName]="selectedStockVariant?.name || selectedStockVariant?.title"
      (closed)="closeStockDetails()"
      (addStockClicked)="openAddStockFromDetails()"
    ></app-product-stock-details>
  </div>
</div>